// components
import { Box, InputAdornment } from '@mui/material';
import {
  StyledBoxFlexStretch,
  StyledBoxFullWidth
} from 'components/shared/Box/Box.styles';
import {
  ControlledSelect,
  ControlledTextField
} from 'components/shared/ControlledFields';

// hooks
import { useTranslation } from 'react-i18next';
import { useFormContext, useWatch } from 'react-hook-form';

// styles
import {
  StyledControlledToggleButtonGroup,
  StyledSecondaryTitleTypography
} from './SpecialLeaveFields.styles';
import {
  StyledAddButton,
  StyledAddRowMotionBox
} from './SpecialLeaveTab.styles';

// types
import { FormValues } from './SpecialLeaveTab.types';
import { NominalDutySectionProps } from './SpecialLeaveFields.types';

const NominalDutySection = ({
  isEditable = false,
  handleAddOrUpdateRow,
  editingRowId,
  dutyHourTypeOptions
}: NominalDutySectionProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.cla.specialLeave.settings'
  });
  const { t: tCommon } = useTranslation();
  const { control } = useFormContext<FormValues>();
  const [specialLeaveImportCode, specialLeavePercentage] = useWatch({
    control,
    name: ['specialLeaveImportCode', 'specialLeavePercentage']
  });

  return (
    <>
      <StyledSecondaryTitleTypography variant="h6">
        {t('nominalDuties')}
      </StyledSecondaryTitleTypography>
      {isEditable && (
        <Box>
          <StyledAddRowMotionBox key="motion-special-leave-tab-add-row" layout>
            <StyledBoxFullWidth>
              <ControlledTextField
                control={control}
                name="specialLeaveImportCode"
                variant="outlined"
                label={tCommon('costCenterDetail.importCode')}
                fullWidth
                slotProps={{ inputLabel: { shrink: !!specialLeaveImportCode } }}
              />
            </StyledBoxFullWidth>
            <StyledBoxFullWidth>
              <ControlledTextField
                control={control}
                name="specialLeavePercentage"
                variant="outlined"
                label={tCommon('percentage')}
                slotProps={{
                  inputLabel: { shrink: !!specialLeavePercentage },
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                    )
                  }
                }}
                fullWidth
              />
            </StyledBoxFullWidth>
            <StyledBoxFullWidth>
              <ControlledSelect
                control={control}
                variant="outlined"
                name="specialLeaveDutyHourTypeId"
                placeholder={t('selectDutyHourType')}
                label=""
                options={dutyHourTypeOptions ?? []}
                hasClearButton
                displayEmpty
                fullWidth
              />
            </StyledBoxFullWidth>
            <StyledBoxFlexStretch>
              <StyledControlledToggleButtonGroup
                control={control}
                name="specialLeaveProcessAsNegative"
                color="secondary"
                disabled={!isEditable}
                inputToggleButtons={[
                  {
                    label: t('POSITIVE'),
                    value: false
                  },
                  {
                    label: t('NEGATIVE'),
                    value: true
                  }
                ]}
              />
              <StyledControlledToggleButtonGroup
                control={control}
                name="specialLeavePeriod"
                color="secondary"
                disabled={!isEditable}
                inputToggleButtons={[
                  {
                    label: t('WEEKLY'),
                    value: 'WEEKLY'
                  },
                  {
                    label: t('MONTHLY'),
                    value: 'MONTHLY'
                  }
                ]}
              />
            </StyledBoxFlexStretch>

            <Box>
              <StyledAddButton color="primary" onClick={handleAddOrUpdateRow}>
                {editingRowId !== null ? t('update') : t('add')}
              </StyledAddButton>
            </Box>
          </StyledAddRowMotionBox>
        </Box>
      )}
    </>
  );
};

export default NominalDutySection;
